import React from 'react';
import SureModalSC from './sure-modal.styled';
import { HeadingTwo, BodyText } from '../../../typography';
import { FormattedMessage, injectIntl } from 'react-intl';
import dlt from '../../../../utils/default-lang';
import Button from '../../../ui/button';

const SureModal = ({ onSubmit }) => {
  return (
    <SureModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage
            id="investor_loan_detail_transfer_of_claim_sure_modal_headline"
            defaultMessage={dlt['investor_loan_detail_transfer_of_claim_sure_modal_headline']}
          />
        </HeadingTwo>
        <BodyText>
          <FormattedMessage
            id="investor_loan_detail_transfer_of_claim_sure_modal_text"
            defaultMessage={dlt['investor_loan_detail_transfer_of_claim_sure_modal_text']}
          />
        </BodyText>
      </div>

      <div className="submit-wrap">
        <Button type="PRIMARY" size="BIG" onClick={() => onSubmit(true)}>
          <FormattedMessage
            id="investor_loan_detail_transfer_of_claim_sure_modal_sign_button"
            defaultMessage={dlt['investor_loan_detail_transfer_of_claim_sure_modal_sign_button']}
          />
        </Button>
        <Button type="OUTLINED" size="BIG" onClick={() => onSubmit(false)}>
          <FormattedMessage
            id="investor_loan_detail_transfer_of_claim_sure_modal_do_not_sign_button"
            defaultMessage={
              dlt['investor_loan_detail_transfer_of_claim_sure_modal_do_not_sign_button']
            }
          />
        </Button>
      </div>
    </SureModalSC>
  );
};

export default injectIntl(SureModal);
